import { render, staticRenderFns } from "./CameraSuim.vue?vue&type=template&id=16f6f0f8&scoped=true&"
import script from "./CameraSuim.vue?vue&type=script&lang=js&"
export * from "./CameraSuim.vue?vue&type=script&lang=js&"
import style0 from "./CameraSuim.vue?vue&type=style&index=0&id=16f6f0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f6f0f8",
  null
  
)

export default component.exports